export enum CarriersName {
  GEODIS = "Geodis",
  COLISSIMO = "Colissimo",
  DHL = "DHL",
  GLS = "GLS",
  TUT_TUT = "Tut Tut",
  RELAISCOLIS = "Relais Colis",
  POST_OFFICE = "Post Office French Post",
  PAACK = "Paack",
  DPD = "DPD",
  UPS = "UPS",
  GEEV = "GEEV",
}

export enum CarrierRole {
  CARRIER = "CARRIER",
  RETAILER = "RETAILER",
}

export enum DisablingRequestedBy {
  CARRIER = "CARRIER",
  PICKME_CARE = "PICKME_CARE",
  PICKME_OPS = "PICKME_OPS",
  KEEPER = "KEEPER",
}

export enum DisablingReason {
  TEMPORARY_UNAVAILABILITY = "TEMPORARY_UNAVAILABILITY",
  ACTIVITY_STOP = "ACTIVITY_STOP",
  KEEPER_UNREACHABLE = "KEEPER_UNREACHABLE",
  SCHEDULE_NON_COMPLIANCE = "SCHEDULE_NON_COMPLIANCE",
  BEHAVIOR_ISSUE = "BEHAVIOR_ISSUE",
  ROUTE_INCOMPATIBILITY = "ROUTE_INCOMPATIBILITY",
  ADDRESS_INVALID = "ADDRESS_INVALID",
  INTERNAL_INVESTIGATION = "INTERNAL_INVESTIGATION",
  POLICY_VIOLATION = "POLICY_VIOLATION",
  OTHER = "OTHER",
}

export enum ManualCarrierLabel {
  UPS = `🚛 ${CarriersName.UPS}`,
  RELAISCOLIS = `🚛 ${CarriersName.RELAISCOLIS}`,
}

export interface CreateOrderCarrier {
  value: string
  label: string
  type: CarrierRole
}

export interface KeeperCarrier {
  allowed: boolean
  carrierId: string
  carrierName: string
  externalId?: string
}

export interface AllowedCarrierProps {
  carrier: KeeperCarrier
  updateAllowedCarrier: (details?: DisablingDetails) => void
  loading: boolean
}

export interface KeeperCarrierButtonProps {
  carrier: KeeperCarrier
  cursor?: boolean
  loading: boolean
}

export interface CarrierAPIProps {
  copyData?: (data: any, carrier: { value: string; label: string; type: CarrierRole }) => void
}

export interface DisablingDetails {
  disablingRequestedBy: DisablingRequestedBy
  disablingReason: DisablingReason
  internalComment?: string
}
